export default class checkNIP {
    constructor() {
        // SOAP on the server must be enabled!
        this.inputNIP = document.getElementById("vat_number");
        this.getDataWait = document.getElementById("vat_number-gusApi");

        if (this.inputNIP && document.documentElement.lang == "pl-PL") {
            this.events();
        }
    }

    events() {
        if (this.getDataWait) {
            this.getDataWait.style.display = "none";
        }
    }

    events() {
        this.getDataWait.style.display = "none";

        this.inputNIP.addEventListener("input", this.getData.bind(this));
    }

    getData() {
        // SOAP on the server must be enabled!
        if (this.inputNIP.value.length === 10) {
            const data = {
                action: "checkNIP",
                nip: this.inputNIP.value,
            };
            jQuery.ajax({
                url: ajax.ajaxurl,
                type: "POST",
                data: data,
                beforeSend: function () {
                    document.getElementById("vat_number-gusApi").style.display =
                        "block";
                    document.getElementById("vat_number-gusApi").innerHTML =
                        "Pobieranie danych...";
                },
                success: function (response) {
                    if (response.includes("StatusSesji:1")) {
                        document.getElementById("vat_number-gusApi").innerHTML =
                            "NIP niepoprawny - nie znaleziono podmiotu";
                    } else {
                        if (isNaN(data.nip) == true) {
                            document.getElementById(
                                "vat_number-gusApi"
                            ).innerHTML = response.replace(/['"]+/g, "");
                        } else {
                            const obj = JSON.parse(response);

                            document.getElementById("billing_address_1").value =
                                obj.street;

                            const address_2 =
                                document.getElementById("billing_address_2");

                            if (address_2) {
                                if (obj.a_number != "") {
                                    address_2.value =
                                        obj.s_number + "/" + obj.a_number;
                                } else {
                                    address_2.value = obj.s_number;
                                }
                            }

                            document.getElementById("billing_postcode").value =
                                obj.zipCode;
                            document.getElementById("billing_city").value =
                                obj.city;

                            const company =
                                document.getElementById("billing_company");
                            if (company) {
                                company.value = obj.name;
                            } else {
                                document.getElementById(
                                    "billing_company"
                                ).value = obj.name;
                            }

                            document.getElementById(
                                "vat_number-gusApi"
                            ).style.display = "none";
                        }
                    }
                },

                error: function (request) {
                    console.log(request.responseText);
                },
            });
        } else {
            document.getElementById("vat_number-gusApi").style.display = "none";
        }
    }
}
